import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../ManagedCyberDefence.css';

const ManagedCyberDefenceHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>שירות הגנת סייבר מנוהל 24/7 - SOC כשירות | Epicfinal</title>
                <meta name="title" content="שירות הגנת סייבר מנוהל 24/7 - SOC כשירות | Epicfinal" />
                <meta name="description" content="הגנת סייבר מנוהלת עם ניטור 24/7, זיהוי איומים ותגובה לאירועים לעד 50 נקודות קצה (Endpoints). תמיכה בווינדוס ולינוקס. חקירות המובלות על ידי בני אדם ללא צורך בהקמת SOC משלכם." />
                <meta name="keywords" content="הגנת סייבר מנוהלת, SOC כשירות, שירותי אבטחה מנוהלים, אבטחת נקודות קצה, זיהוי איומים, תגובה לאירועים, הגנת כופר, ניטור 24/7, מרכז מבצעי אבטחה, MDR, זיהוי ותגובה מנוהלים, אבטחת ווינדוס, אבטחת לינוקס" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/managed-cyber-defence" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/managed-cyber-defence" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/managed-cyber-defence" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/managed-cyber-defence" />
                <meta property="og:title" content="הגנת סייבר מנוהלת 24/7 - SOC כשירות | Epicfinal" />
                <meta property="og:description" content="הגנת סייבר מנוהלת עם זיהוי ותגובה לאיומים 24/7 לעד 50 נקודות קצה. חזקו את האבטחה ללא צורך בהקמת SOC." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal הגנת סייבר מנוהלת - מבצעי אבטחה 24/7" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/managed-cyber-defence" />
                <meta name="twitter:title" content="שירות הגנת סייבר מנוהל 24/7 | Epicfinal" />
                <meta name="twitter:description" content="זיהוי איומים ותגובה לאירועים 24/7 לעד 50 נקודות קצה. תמיכה בווינדוס ולינוקס." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "שירות הגנת סייבר מנוהל",
                        "description": "שירות אבטחה מנוהל 24/7 הכולל ניטור רציף, זיהוי איומים ותגובה מודרכת לאירועים עבור נקודות קצה וזהויות",
                        "provider": {"@type": "Organization", "name": "Epicfinal", "url": "https://epicfinal.com"},
                        "serviceType": "שירות אבטחה מנוהל",
                        "areaServed": "Worldwide",
                        "url": "https://epicfinal.com/he/managed-cyber-defence"
                    }
                `}</script>
            </Helmet>

            <div className="cyber-defence-page">
                {/* Hero Section */}
                <section className="cyber-hero">
                    <div className="container">
                        <div className="cyber-hero-content">
                            <div className="cyber-icon-badge">
                                <i className="las la-shield-alt"></i>
                            </div>
                            <h1 className="cyber-hero-title">
                                שירות הגנת סייבר מנוהל 24/7
                            </h1>
                            <p className="cyber-hero-subtitle">
                                חזקו את האבטחה שלכם מבלי להקים SOC משלכם.
                            </p>
                            <p className="cyber-hero-description">
                                שירות הגנת הסייבר המנוהל שלנו מעניק לעסק שלכם ניטור רציף, זיהוי איומים ותגובה מודרכת עבור נקודות קצה (Endpoints) וזהויות – הכל ניתן כשירות מנוהל, 24/7.
                            </p>
                            <p className="cyber-hero-description secondary">
                                אנו משלבים סוכנים קלי משקל, אנליטיקת אבטחה מודרנית וצוות מבצעי אבטחה ייעודי, כדי שתוכלו להפחית סיכונים, לזהות איומים מוקדם יותר ולהגיב מהר יותר, מבלי לטבוע בהתראות.
                            </p>
                            <div className="cyber-hero-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-cyber-defense-service&language=hebrew&currency=2" 
                                   className="btn-cyber btn-primary" target="_blank" rel="noopener noreferrer">
                                    התחילו עכשיו
                                </a>
                                <Link to="/contact1" className="btn-cyber btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                            <div className="cyber-hero-badges">
                                <span className="badge"><i className="lab la-windows"></i> Windows</span>
                                <span className="badge"><i className="lab la-linux"></i> Linux</span>
                                <span className="badge"><i className="las la-desktop"></i> עד 50 נקודות קצה</span>
                            </div>
                        </div>
                    </div>
                    <div className="cyber-hero-bg-elements">
                        <div className="hex hex-1"></div>
                        <div className="hex hex-2"></div>
                        <div className="hex hex-3"></div>
                    </div>
                </section>

                {/* Key Benefits Section */}
                <section className="cyber-benefits">
                    <div className="container">
                        <div className="cyber-section-header">
                            <h2>יתרונות מרכזיים</h2>
                            <p>אבטחה ברמה ארגונית ללא המורכבות הארגונית</p>
                        </div>
                        <div className="cyber-benefits-grid">
                            <div className="cyber-benefit-card">
                                <div className="cyber-benefit-icon">
                                    <i className="las la-eye"></i>
                                </div>
                                <h3>ניטור נקודות קצה 24/7</h3>
                                <p>נראות רציפה להתנהגות חשודה בנקודות קצה של Windows, macOS ו-Linux (במידת האפשר), בתוספת אותות זהות קריטיים מהסביבה שלכם.</p>
                            </div>
                            <div className="cyber-benefit-card">
                                <div className="cyber-benefit-icon">
                                    <i className="las la-user-secret"></i>
                                </div>
                                <h3>חקירות איומים המובלות על ידי בני אדם</h3>
                                <p>איומים פוטנציאליים נבדקים על ידי אנליסטים של אבטחה, מה שעוזר להבחין בין התקפות אמיתיות לרעש חסר חשיבות, כך שהצוות שלכם יוכל להתמקד בנושאים החשובים.</p>
                            </div>
                            <div className="cyber-benefit-card">
                                <div className="cyber-benefit-icon">
                                    <i className="las la-crosshairs"></i>
                                </div>
                                <h3>זיהוי מוקדם של איומים חמורים</h3>
                                <p>השירות נועד לזהות טכניקות המשמשות בהתקפות בעולם האמיתי – כגון מנגנוני קביעות (Persistence), התנהגות זדונית של תהליכים וסימנים לפעילות כופר – כדי לעזור לכם לפעול לפני שהנזק מתפשט.</p>
                            </div>
                            <div className="cyber-benefit-card">
                                <div className="cyber-benefit-icon">
                                    <i className="las la-file-medical-alt"></i>
                                </div>
                                <h3>הכלה ותיקון מודרכים</h3>
                                <p>כאשר מזוהה איום מאומת, אתם מקבלים דוח אירוע ברור עם פעולות מומלצות כדי שהצוות שלכם ידע מה לעשות הלאה כדי להכיל ולהסיר את האיום.</p>
                            </div>
                            <div className="cyber-benefit-card">
                                <div className="cyber-benefit-icon">
                                    <i className="lab la-microsoft"></i>
                                </div>
                                <h3>שימוש טוב יותר ב-Microsoft Defender</h3>
                                <p>עבור סביבות המשתמשות ב-Microsoft Defender Antivirus, אנו יכולים לסייע ביישום הגדרות מומלצות ובניטור חריגות מסוכנות, כך שתקבלו ערך רב יותר מכלים שכבר נמצאים ברשותכם.</p>
                            </div>
                            <div className="cyber-benefit-card">
                                <div className="cyber-benefit-icon">
                                    <i className="las la-handshake"></i>
                                </div>
                                <h3>מודל פשוט מבוסס שירות</h3>
                                <p>אתם מקבלים שירות מנוהל עם ניטור שוטף ותמיכת מומחים, ולא רק עוד תוכנה שעליכם לפרוס ולתחזק בעצמכם.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* What the Service Does Section */}
                <section className="cyber-service-does">
                    <div className="container">
                        <div className="cyber-section-header light">
                            <h2>מה השירות עושה</h2>
                            <p>כיסוי אבטחה מקיף המותאם לסביבה שלכם</p>
                        </div>
                        <div className="cyber-service-list">
                            <div className="cyber-service-item">
                                <div className="cyber-service-check">
                                    <i className="las la-check"></i>
                                </div>
                                <p>ניטור נקודות קצה וזהויות נתמכות עבור התנהגות חשודה מסביב לשעון</p>
                            </div>
                            <div className="cyber-service-item">
                                <div className="cyber-service-check">
                                    <i className="las la-check"></i>
                                </div>
                                <p>זיהוי טכניקות תוקפים נפוצות כגון מנגנוני קביעות (Persistence) ושימוש לרעה בכלים לגיטימיים</p>
                            </div>
                            <div className="cyber-service-item">
                                <div className="cyber-service-check">
                                    <i className="las la-check"></i>
                                </div>
                                <p>מתן אינדיקטורים מוקדמים לפעילות כופר אפשרית</p>
                            </div>
                            <div className="cyber-service-item">
                                <div className="cyber-service-check">
                                    <i className="las la-check"></i>
                                </div>
                                <p>הדגשת תנאים מסוכנים בנקודות קצה (למשל, שירותים חשופים או אחסון אישורים לא מאובטח), כדי שתוכלו להקשיח את הסביבה שלכם</p>
                            </div>
                            <div className="cyber-service-item">
                                <div className="cyber-service-check">
                                    <i className="las la-check"></i>
                                </div>
                                <p>אספקת דוחות אירועי אבטחה שנבדקו על ידי בני אדם עם הסברים בשפה פשוטה וצעדים מעשיים</p>
                            </div>
                            <div className="cyber-service-item">
                                <div className="cyber-service-check">
                                    <i className="las la-check"></i>
                                </div>
                                <p>עבודה לצד תהליכי ה-IT והאבטחה הקיימים שלכם במקום להחליף אותם</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Disclaimer Section */}
                <section className="cyber-disclaimer">
                    <div className="container">
                        <div className="cyber-disclaimer-card">
                            <div className="cyber-disclaimer-icon">
                                <i className="las la-info-circle"></i>
                            </div>
                            <div className="cyber-disclaimer-content">
                                <h3>זה לא ביטוח סייבר.</h3>
                                <p>השירות אינו מספק כל צורה של כיסוי פיננסי, כיסוי משפטי או פיצוי על אירועים. הוא אינו מחליף פוליסת ביטוח סייבר או כל מוצר אחר להעברת סיכונים.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Level Up Section */}
                <section className="cyber-level-up">
                    <div className="container">
                        <div className="cyber-level-up-content">
                            <h2>דרך פשוטה לשדרג את האבטחה שלכם</h2>
                            <p className="intro-text">
                                בין אם יש לכם צוות IT קטן או מחלקה מבוססת, הקמת יכולת מבצעי אבטחה מלאה 24/7 בעצמכם היא יקרה וגוזלת זמן.
                            </p>
                            <div className="cyber-level-up-grid">
                                <div className="cyber-level-up-item">
                                    <i className="las la-clock"></i>
                                    <span>ניטור וחקירות שתמיד פעילים</span>
                                </div>
                                <div className="cyber-level-up-item">
                                    <i className="las la-user-shield"></i>
                                    <span>גישה למומחיות אבטחה מיוחדת</span>
                                </div>
                                <div className="cyber-level-up-item">
                                    <i className="las la-file-alt"></i>
                                    <span>דוחות אירועים ברורים והדרכה מעשית</span>
                                </div>
                                <div className="cyber-level-up-item">
                                    <i className="las la-chart-line"></i>
                                    <span>מודל שירות צפוי ללא צורך באיוש SOC מסביב לשעון</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="cyber-pricing">
                    <div className="container">
                        <div className="cyber-pricing-card">
                            <div className="cyber-pricing-header">
                                <h2>שירות הגנת סייבר מנוהל</h2>
                                <p>הגנה מקיפה על נקודות קצה לעסק שלכם</p>
                            </div>
                            <div className="cyber-pricing-body">
                                <ul className="cyber-pricing-features">
                                    <li><i className="las la-check"></i> ניטור רציף 24/7</li>
                                    <li><i className="las la-check"></i> זיהוי וניתוח איומים</li>
                                    <li><i className="las la-check"></i> חקירות המובלות על ידי בני אדם</li>
                                    <li><i className="las la-check"></i> תגובה מודרכת לאירועים</li>
                                    <li><i className="las la-check"></i> עד 50 נקודות קצה (מכונות וירטואליות / פיזיות / תחנות עבודה)</li>
                                    <li><i className="las la-check"></i> תמיכה בווינדוס ולינוקס</li>
                                    <li><i className="las la-check"></i> צוות אבטחה ייעודי</li>
                                </ul>
                                <div className="cyber-pricing-platforms">
                                    <span className="platform-badge"><i className="lab la-windows"></i> Windows</span>
                                    <span className="platform-badge"><i className="lab la-linux"></i> Linux</span>
                                </div>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-cyber-defense-service&language=hebrew&currency=2" 
                                   className="cyber-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    התחילו עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cyber-cta">
                    <div className="container">
                        <div className="cyber-cta-content">
                            <h2>מוכנים לחזק את האבטחה שלכם?</h2>
                            <p>תנו למומחים שלנו להגן על העסק שלכם, בזמן שאתם מתמקדים במה שחשוב באמת.</p>
                            <div className="cyber-cta-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-cyber-defense-service&language=hebrew&currency=2" 
                                   className="btn-cyber btn-light" target="_blank" rel="noopener noreferrer">
                                    הזמינו שירות
                                </a>
                                <a href="https://meetings.hubspot.com/viacheslav-seifer" 
                                   className="btn-cyber btn-outline" target="_blank" rel="noopener noreferrer">
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ManagedCyberDefenceHe;
